exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-dialog-content {\n  max-height: 55vh;\n  padding: 0; }\n\nh6 {\n  padding-bottom: 8px; }\n\n#empresas-scroll {\n  overflow-y: scroll;\n  height: 45vh; }\n\n.divider {\n  margin: 0 -24px; }\n\n.profile-picture {\n  height: 40px;\n  width: 40px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/dialog/empresas-dialog/empresas-dialog.component.scss
// module id = ../../../../../src/app/components/common/dialog/empresas-dialog/empresas-dialog.component.scss
// module chunks = 0